<app-dialog
  #dialog
  [key]="'meeting-recording'"
  [action]="'meeting-recording'"
  [headerTheme]="'simple'"
  [title]="'Gravação da reunião'"
  [maxWidth]="'960px'"
  [showMaximizeButton]="true"
  (onClose)="aoFechar()">
  <div class="meeting-recording">
    @if (ligacao(); as meeting) {
      <p class="meeting-recording__title">
        {{ meeting.title }} · {{ meeting.scheduledStartAt | vaultDateTime }}
      </p>
    }

    @if (carregando()) {
      <div class="meeting-recording__state">
        <app-cog-loading-spinner [size]="56" />
        <span>Buscando a gravação...</span>
      </div>
    } @else if (erro()) {
      <div class="meeting-recording__state meeting-recording__state--error" role="alert">
        <i class="pi pi-video" aria-hidden="true"></i>
        <span>{{ erro() }}</span>
      </div>
    } @else if (url()) {
      <!-- `preload="metadata"`: a gravação pode ter centenas de MB, e só a duração/primeiro
           quadro são necessários antes do play. -->
      <video
        class="meeting-recording__video"
        controls
        preload="metadata"
        [src]="url()"
        (error)="videoFalhou()">
        Seu navegador não reproduz este vídeo.
      </video>
    }
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Fechar'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
